import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export const ProtectedRoute = ({ roles, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-[60vh] items-center justify-center">
        <div className="text-slate-500 text-sm font-mono">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === 'logistics' ? '/logistica' : '/'} replace />;
  }

  return children;
};
